export const FeatureCard = ({ title, description, featureImage, onClick }) => {
	return (
		<div className="flex flex-col items-center justify-center flex-1 border border-gray-200 rounded-lg overflow-hidden">
			<div className="flex flex-col items-center justify-center gap-2 p-4 bg-blue-50 h-48">
				<h3 className="text-lg font-medium text-center">{title}</h3>
				<p className="text-sm text-gray-500 text-center">{description}</p>
			</div>
			<div className="w-full h-96 my-12">
				<img
					src={featureImage}
					alt={title}
					className="w-full h-full object-contain"
				/>
			</div>
			<div className="w-full h-16 flex items-center justify-center">
				<button
					className="bg-blue-500 text-white font-bold py-1 px-4 rounded"
					onClick={onClick}
				>
					Set up
				</button>
			</div>
		</div>
	);
};
